var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m494.672 63.953c0-27.202-22.997-49.254-51.365-49.254h-357.12c-28.368 0-51.365 22.052-51.365 49.254v301.92c0 13.063 5.412 25.591 15.045 34.828s22.697 14.426 36.32 14.426h357.12c13.623 0 26.688-5.189 36.321-14.426s15.044-21.765 15.044-34.828z",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.672 63.983c0-13.071-5.415-25.607-15.053-34.849-9.639-9.243-22.712-14.435-36.343-14.435-88.48 0-268.577 0-357.058 0-13.631 0-26.703 5.192-36.342 14.435-9.639 9.242-15.054 21.778-15.054 34.849v33.219h459.85s0-15.592 0-33.219z",
    fill: "#cad0d7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.289,
    cy: 55.95,
    fill: "#f76c82",
    rx: 12.25,
    ry: 12.255
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.97,
    cy: 55.95,
    fill: "#fdcd56",
    rx: 12.25,
    ry: 12.255
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.652,
    cy: 55.95,
    fill: "#c6ea94",
    rx: 12.25,
    ry: 12.255
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96.369 410.968-20.566-14.192 27.391-39.693 20.565 14.192z",
    fill: "#a9b0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.842 402.192c5.195 3.585 6.51 10.756 2.925 15.951l-49.831 72.213c-3.57 5.193-10.756 6.511-15.951 2.926l-15.712-10.842c-5.195-3.586-6.51-10.756-2.925-15.951l49.831-72.214c3.585-5.195 10.771-6.513 15.951-2.925z",
    fill: "#a9b0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.144 211.323c48.565-8.906 95.162 23.248 104.068 71.814 8.907 48.565-23.247 95.162-71.813 104.068-48.566 8.907-95.162-23.247-104.069-71.813-8.906-48.566 23.248-95.162 71.814-104.069z",
    fill: "#cad0d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.271 239.543c32.984 0 59.725 26.741 59.725 59.725s-26.741 59.718-59.725 59.718-59.718-26.734-59.718-59.718h-.007c0-32.984 26.741-59.725 59.725-59.725z",
    fill: "#f4f6f8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.271 313.594c-18.96 0-35.234 11.491-42.238 27.898 10.813 10.807 25.746 17.494 42.238 17.494 16.499 0 31.432-6.687 42.239-17.494-6.998-16.407-23.278-27.898-42.239-27.898z",
    fill: "#4fc0e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.06 280.152c0 11.716 9.495 21.211 21.211 21.211 11.724 0 21.218-9.495 21.218-21.211 0-11.717-9.494-21.218-21.218-21.218-11.716 0-21.211 9.501-21.211 21.218z",
    fill: "#b9835e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m289.243 306.613c0 7.678 6.221 13.899 13.899 13.899 7.674 0 13.895-6.221 13.895-13.899 0-7.674-6.221-13.895-13.895-13.895-7.678 0-13.899 6.221-13.899 13.895z",
    fill: "#d5a889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.208 358.589c0 16.605-60.136 16.605-60.136 0 0-16.606 13.465-30.07 30.07-30.07s30.066 13.464 30.066 30.07z",
    fill: "#66d4f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m349.378 306.613c0 7.678 6.221 13.899 13.9 13.899 7.673 0 13.895-6.221 13.895-13.899 0-7.674-6.222-13.895-13.895-13.895-7.679 0-13.9 6.221-13.9 13.895z",
    fill: "#b9835e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.343 358.589c0 16.605-60.135 16.605-60.135 0 0-16.606 13.464-30.07 30.07-30.07 16.605 0 30.065 13.464 30.065 30.07z",
    fill: "#4fc0e8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m409.514 306.613c0 7.678 6.221 13.899 13.899 13.899 7.674 0 13.895-6.221 13.895-13.899 0-7.674-6.221-13.895-13.895-13.895-7.678 0-13.899 6.221-13.899 13.895z",
    fill: "#d5a889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.479 358.589c0 16.605-60.136 16.605-60.136 0 0-16.606 13.465-30.07 30.07-30.07 16.606 0 30.066 13.464 30.066 30.07z",
    fill: "#66d4f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406.322 175.875v62.331c0 2.762-2.239 5-5 5-15.221 0-60.873 0-76.093 0-2.761 0-5-2.238-5-5 0-15.598 0-62.331 0-62.331z",
    fill: "#e4e8eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.89 209.541h20.983v33.666h-20.983z",
    fill: "#937661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.996 167.651c1.254 1.487 1.532 3.566.712 5.331-.819 1.764-2.588 2.893-4.534 2.893-24.019 0-81.778 0-105.797 0-1.946 0-3.715-1.129-4.535-2.893-.819-1.765-.541-3.844.713-5.331 7.607-9.016 19.278-22.851 23.393-27.727.95-1.126 2.348-1.776 3.821-1.776h59.012c1.474 0 2.872.65 3.822 1.776 4.114 4.876 15.786 18.711 23.393 27.727z",
    fill: "#f76c82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorPerformance);
export default __webpack_public_path__ + "static/media/vendor-performance.0ac4ecfcfb95d67f44f99068efb0a98b.svg";
export { ForwardRef as ReactComponent };